<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-service size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Diagnosis</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-service" centered title="New Diagnosis" title-class="font-18" hide-footer>
        <form @submit.prevent="addDiagnosis">
            <div class="form-group mb-2">
            <label>Diagnosis Name</label>
            <input v-model="name" type="text" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-service')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { diseaseMethods, diseaseComputed } from "@/state/helpers";

export default {
  page: {
    title: "Facility Diagnoses",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      title: "Facility Diagnoses",
      items: [ {text: "Dashboard",to: "/",}, {text: "Facility Diagnoses",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'name', label: 'Diagnosis Name', visible: true },
        ],
      id:'',
      name:'',
    };
  },
  computed: {
    ...diseaseComputed,
    List() { return this.diseases.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.diseases.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.diseases.length>0) { a=false;} else { a=true;} return a },
  },
  mounted() {
    this.fetchDiseases();
    this.TotalRows = this.diseases.length;
    this.isBusy=false;
  },
  methods: {
    ...diseaseMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async addDiagnosis() { 
      let formData = new FormData();
      formData.append("name", this.name);
      let url = "/adddisease";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchDiseases();
          this.$bvModal.hide('new-service');
          this.name="";
      }
      });
    },
  },
};
</script>